module.exports = "subfilemodule";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/single-file-module/~/subfilemodule.js
 ** module id = 1
 ** module chunks = 0
 **/